import {Col, Row} from "antd";
import React from "react";

//assumes no dumb values to blow out of 24 range

export function Spread(
    {
        left, right, middle,
        leftStyle, rightStyle, middleStyle,
        style,
        leftCol=-1, rightCol=-1,
        ...props
    }) {


    let middleCol = 8;
    if (leftCol < 0 && rightCol < 0) {
        leftCol = rightCol = middle ? 8 : 12;
    } else if (leftCol > -1 && rightCol > -1) {
        middleCol = 24 - leftCol - rightCol;
    } else if (leftCol < 0) {
        leftCol = middleCol = (24 - rightCol) / (middle ? 2 : 1);
    } else {
        rightCol = middleCol= (24 - leftCol) / (middle ? 2 : 1);
    }

    return <Row style={{marginBottom: 10, ...style}} {...props}>
        <Col span={leftCol}
             style={{textAlign: 'left', ...leftStyle}}
        >{left}</Col>
        {middle &&
            <Col span={middleCol}
                 style={{margin: '0,auto', width: 'fit-content', ...middleStyle}}
            >{middle}</Col>}
        <Col span={rightCol}
             style={{textAlign: 'right', ...rightStyle}}
        >{right}</Col>
    </Row>
}